<template>
    <div class="ngdialog-content">
        <div class="ngdialog__header">
            <h4>{{$t('certificates.show_certificate')}}</h4>
            <div class="ngdialog-close" @click="$emit('close')"></div>
        </div>

        <div class="ngdialog__body">
            <p>
                <b>{{$t('certificates.csr')}}</b>
                <br>
                <pre v-html="certificate.csr" class="monospace"></pre>
            </p>
            <p>
                <b>{{$t('certificates.id')}}</b>
                <br>
                {{certificate.id}}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        certificate: Object,
    },
};
</script>
